













































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UpgradeJob, UpgradeJobType } from '@/types/upgradejob';
import { UpgradeReportType } from '@/types/upgradereporttype';
import { upgradeJobTabs } from '@/types/upgradejobtabs';
import UpgradeJobs from '../views/UpgradeJobs.vue';

@Component({
  name: 'settings-and-config-upgrade-report-job-form',
  props: {
    isCurrentlySelected: Boolean,
    currentlySelectedFiId: Number,
    previousReportHistory: Array,
    jobOnThisTabRunning: Boolean,
  },
})
export default class SettingsAndConfigUpgradeReportJobForm extends Vue {
	upgradeJobTabs = upgradeJobTabs;

	loading:boolean = false;

	errorMessage:string = '';

	loadedReportsForFi:string = '';

	isJobOnThisTabRunning() {
	  return this.$props.jobOnThisTabRunning;
	}

	emitDownloadReport(s3Key:string, versionId:string) {
	  this.$emit('downloadPreviousReportVersion', UpgradeReportType.SETTINGS, s3Key, versionId);
	}

	emitRunSelectedUpgradeJob() {
	  this.$emit('runSelectedUpgradeJob', UpgradeJobType.SETTINGS,
	  	SettingsAndConfigUpgradeReportJobForm.getRunReportUrl(), this.getRunReportRequestBody());
	}

	getRunReportRequestBody() {
	  return {
	    fiId: this.$props.currentlySelectedFiId,
	  };
	}

	static getRunReportUrl() {
	  return '/api/krp/admin/upgrade/settings';
	}

	areNoReportsForSelectedFi() {
	  return this.$props.previousReportHistory && this.$props.previousReportHistory.length === 0;
	}

	arePreviousReportsLoaded() {
	  return this.$props.previousReportHistory && this.$props.previousReportHistory.length > 0;
	}

	resetErrorMessage() {
	  this.errorMessage = '';
	}
}
